import React from 'react';
import { Clock } from 'lucide-react';
import { ENTITY } from '../utils/constants';

const PostCard = ({ post, onClick, isHighPriority = false }) => {
  const handleClick = () => onClick(post);
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  const baseUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const rawImageUrl = post.imageUrl || '';
  const isAbsoluteImageUrl = /^(?:[a-z]+:)?\/\//i.test(rawImageUrl);
  const imageUrl = isAbsoluteImageUrl
    ? rawImageUrl
    : `${baseUrl}/${rawImageUrl.replace(/^\/+/, '')}`;
  const webpUrl = imageUrl.replace(/\.(jpg|jpeg|png)$/i, '.webp');

  return (
    <div
      className="post-card"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
      <div className="card-image">
        <picture>
          <source srcSet={webpUrl} type="image/webp" />
          <img
            src={imageUrl}
            alt={post.name}
            loading={isHighPriority ? 'eager' : 'lazy'}
            fetchpriority={isHighPriority ? 'high' : 'auto'}
            decoding={isHighPriority ? 'sync' : 'async'}
          />
        </picture>
        {post.easy && (
          <div className="card-overlay">
            <Clock size={16} suppressHydrationWarning />{' '}
            {ENTITY.labels.easyOverlay}
          </div>
        )}
      </div>
      <div className="card-content">
        <h3>{post.name}</h3>
        <div className="card-tags">
          {(post.tags || []).slice(0, 2).map((tag) => (
            <span key={tag} className="card-tag">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default React.memo(PostCard);
